import { MarketingAttribution } from 'classes/marketing-attribution'

document.addEventListener('turbolinks:load', () => {
  const marketingAttribution = new MarketingAttribution

  marketingAttribution.persistMarketingParams()
}, true)
